import ProductAvailableStoresCount, {
    getProductAvailabilityEShopTwClass,
} from 'components/Blocks/Product/Availability/ProductAvailableStoresCount';
import { Item, ItemProps, TEST_IDENTIFIER } from 'components/Blocks/Product/CategoryPromotedProducts/Item/Item';
import { ProductLink } from 'components/Blocks/Product/CategoryPromotedProducts/Item/ProductLink';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { getSellingPriceByDomain, useFormatPrice } from 'hooks/formatting/useFormatPrice';
import useTranslation from 'next-translate/useTranslation';
import { twJoin } from 'tailwind-merge';
import { AvailabilityStatusEnum } from 'types/availability';

export const B2cItem: FC<ItemProps> = ({ item, gtmListName, listIndex }) => {
    const domainConfig = useDomainConfig();
    const isElectronicGiftVoucher = item.isElectronicGiftVoucher;
    const { t } = useTranslation();
    const { formatPriceNumber, formatPriceObject } = useFormatPrice();
    const isSpecialPrice =
        getSellingPriceByDomain(item.price, domainConfig) < getSellingPriceByDomain(item.prices.basic, domainConfig);

    return (
        <Item item={item}>
            <div className="mr-4 flex flex-1 items-center text-center text-small font-bold">
                <div className={twJoin('w-3/5 pr-7 text-left')} data-testid={TEST_IDENTIFIER + 'name'}>
                    <ProductLink gtmListName={gtmListName} item={item} listIndex={listIndex} />
                </div>

                <div className="block w-2/5 text-left">
                    <span
                        className={getProductAvailabilityEShopTwClass(
                            item.availabilityStatus === AvailabilityStatusEnum.inStock,
                        )}
                    >
                        {item.availability.status === AvailabilityStatusEnum.inStock
                            ? t('Available in eshop')
                            : t('Unavailable in eshop')}
                    </span>
                    {!isElectronicGiftVoucher && (
                        <ProductAvailableStoresCount
                            availableStoresCount={item.availableStoresCount}
                            deliveryDaysFromCentralStore={item.deliveryDaysFromCentralStore}
                            isInCentralStore={item.availabilityStatus === AvailabilityStatusEnum.inStock}
                            isMainVariant={item.isMainVariant}
                        />
                    )}
                </div>
            </div>

            <div
                className="mr-2 flex w-32 items-center justify-end text-right"
                data-testid={TEST_IDENTIFIER + 'totalprice'}
            >
                <div>
                    <div
                        data-testid={TEST_IDENTIFIER + 'price'}
                        className={twJoin(
                            'text-h6 font-bold leading-5 text-primary',
                            isSpecialPrice &&
                                'text-small font-normal leading-4 text-primary line-through decoration-red',
                        )}
                    >
                        {formatPriceObject(item.prices.basic)}
                    </div>
                    {isSpecialPrice && (
                        <>
                            <div className="my-1 inline-block bg-red p-1 text-tiny leading-tight text-white">
                                {`${t('You will save')} `}
                                {formatPriceNumber(
                                    getSellingPriceByDomain(item.prices.basic, domainConfig) -
                                        getSellingPriceByDomain(item.price, domainConfig),
                                )}
                            </div>
                            <div
                                className="text-h6 font-bold leading-5 text-red"
                                data-testid={TEST_IDENTIFIER + 'price-special'}
                            >
                                {formatPriceObject(item.price)}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Item>
    );
};
